import {EventType} from './flow';

export interface GeneralFilter {
  name: string;
  icon: string;
  active: boolean;
  code?: string;
  value?: any;
  class?: string;
  hidden?: boolean;
  type?: 'select' | 'checkbox' | 'date';
  options?: { label: string; value: any }[];
}

export interface AdvancedFilterGroup {
  name: string;
  advancedFiltersItems: AdvancedFilterItem[];
  shownFiltersItems: AdvancedFilterItem[];
  filtersActives: number;
}

// 1. Definir interfaces separadas para cada tipo
export interface SliderFilterItem {
  label: string;
  isActive: boolean;
  type: 'slider';
  value: [number, number]; // Min y Max
  limits: { min: number; max: number };
  path: string;
}

export interface CheckboxFilterItem {
  label: string; // Nombre de la entidad
  value: number | string; // Id de la entidad
  isActive: boolean;
  type: 'checkbox';
  path: string; // Direccion de la propiedad en funcion de una entidad base
  pathToList?: string; // Si es necesario senalar el camino hasta un array y el resto en path
}

interface SpecialFilterItem {
  label: string;
  value: any;
  isActive: boolean;
  type: 'special';
  path: string;
}

interface ComparisionFilterItem {
  label: string; // Label del filtro
  value: { operator: '<='; value: number };
  isActive: boolean;
  type: 'lessEqual';
  path: string; // Direccion de la propiedad en funcion de una entidad base
}

export interface EventFilterItem {
  label: string;
  value: Omit<EventType, "id">;
  idGroup: number[]; // Ids en el grupo
  isActive: boolean;
  type: 'event';
}

export interface DateRangeFilterItem {
  label: string;
  isActive: boolean;
  type: 'date-range';
  value: {
    useRange: boolean;
    exactDate: string;
    startDate: string;
    endDate: string;
  };
  path: string;
}

// Crear un tipo unión
export type AdvancedFilterItem =
  SliderFilterItem
  | CheckboxFilterItem
  | ComparisionFilterItem
  | EventFilterItem
  | SpecialFilterItem
  | DateRangeFilterItem;
